define('lq/events/actions/shareOnLinkedIn',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    var linkedInUrl = 'http://www.linkedin.com/shareArticle';

    function ShareOnLinkedIn(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(ShareOnLinkedIn, EventAction);

    ShareOnLinkedIn.typeName = 'ShareOnLinkedIn';

    ShareOnLinkedIn.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    ShareOnLinkedIn.prototype.execute = function (continuation) {
        var url = linkedInUrl;
        var parameters = this.getParameters();

        if (_.keys(parameters).length)
            url = url + '?' + $.param(parameters);

        window.open(url, '', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0');

        continuation();
    };

    ShareOnLinkedIn.prototype.getParameters = function () {
        var parameters = {
            mini: true, 
            url: this.piping.parameters.replace(this.eventData.linkedIn.url)
        };

        if (this.eventData.linkedIn.title)
            parameters['title'] = this.piping.parameters.replace(this.eventData.linkedIn.title);

        if (this.eventData.linkedIn.summary)
            parameters['summary'] = this.piping.parameters.replace(this.eventData.linkedIn.summary);

        return parameters;
    };

    return ShareOnLinkedIn;
});
